import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'

const styles = theme => ({
  gridRoot: {
    width: '100%',
    maxWidth: '1200px',
    margin: '24px auto',
  },
})

class TitleGrid extends React.Component {
  render() {
    const { classes, theme, spacing, windowWidth } = this.props
    var rootGridProp
    if (windowWidth >= theme.breakpoints.values.md) {
      rootGridProp = {
        spacing: spacing ? spacing : 8,
        style: { marginTop: theme.spacing.unit * 12 }
      }
    }
    else if (windowWidth >= theme.breakpoints.values.sm) {
      rootGridProp = {
        spacing: spacing ? spacing : 8,
        style: { marginTop: theme.spacing.unit * 11 }
      }
    }
    else {
      rootGridProp = {
        spacing: spacing ? spacing : 0,
        style: { marginTop: theme.spacing.unit * 7 }
      }
    }
    return (
      <Grid container className={classes.gridRoot} {...rootGridProp}>
        {this.props.children}
      </Grid>
    )
  }
}

export default withStyles(styles, { withTheme: true })(TitleGrid)



// WEBPACK FOOTER //
// ./src/components/Common/TitleGrid/TitleGrid.js